export const CHECKOUT_URL = "https://pay.monetizze.com.br/KCQ469758";
export const AFFILIATE_URL = "https://pay.monetizze.com.br/SEU-LINK-DE-AFILIADO";
export const PRICE = "29,90";
export const OLD_PRICE = "47,00";
